import { Card, mergeSx, SxProps } from '@cast/design-system';

type Props = {
  children: React.ReactNode;
  sx?: SxProps;
  testId?: string;
};

export const SummaryItem = ({ children, sx, testId }: Props) => {
  return (
    <Card testId={testId} sx={mergeSx({ p: 16, minHeight: '136px' }, sx)}>
      {children}
    </Card>
  );
};
